import React, { useState, useEffect } from "react";

// 🎯 Goal Sprint - Mobile-first Personal Task Tracker
// Break goals into tasks, complete them to earn Focus Flames + Shakti Coins

const STORAGE_KEY_WALLET = "sheearns_shakti_wallet_v1";
const STORAGE_KEY_GOAL = "sheearns_goal_sprint_v1";

export default function GoalSprint() {
  const [wallet, setWallet] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY_WALLET);
      return raw ? JSON.parse(raw) : { coins: 0, totalXP: 0, peacePoints: 0 };
    } catch {
      return { coins: 0, totalXP: 0, peacePoints: 0 };
    }
  });

  const [tasks, setTasks] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY_GOAL);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [newTask, setNewTask] = useState("");
  const [celebratingId, setCelebratingId] = useState(null);

  const addTask = () => {
    if (!newTask.trim()) return;
    const updated = [...tasks, { id: Date.now(), text: newTask, done: false }];
    setTasks(updated);
    setNewTask("");
    localStorage.setItem(STORAGE_KEY_GOAL, JSON.stringify(updated));
  };

  const toggleTask = (id) => {
    const taskIndex = tasks.findIndex(t => t.id === id);
    const wasDone = tasks[taskIndex].done;
    const updated = tasks.map(t => t.id === id ? { ...t, done: !t.done } : t);
    setTasks(updated);
    localStorage.setItem(STORAGE_KEY_GOAL, JSON.stringify(updated));

    // Only reward if newly completed
    if (!wasDone) {
      setCelebratingId(id);
      setTimeout(() => setCelebratingId(null), 800);
      const coinsEarned = 3; // 3 coins per completed task
      const updatedWallet = { ...wallet, coins: wallet.coins + coinsEarned, totalXP: wallet.totalXP + coinsEarned };
      setWallet(updatedWallet);
      localStorage.setItem(STORAGE_KEY_WALLET, JSON.stringify(updatedWallet));
    }
  };

  const resetTasks = () => {
    const reset = tasks.map(t => ({ ...t, done: false }));
    setTasks(reset);
    localStorage.setItem(STORAGE_KEY_GOAL, JSON.stringify(reset));
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 p-4 flex flex-col items-center text-white">
      <h1 className="text-2xl font-bold text-pink-300 mb-2">🎯 Goal Sprint</h1>
      <p className="text-sm text-gray-300 mb-4 text-center max-w-xs">Track your tasks, complete sprints, and earn Focus Flames + Shakti Coins!</p>

      <div className="bg-gray-800 rounded-2xl p-4 shadow-lg w-full max-w-md border border-gray-700">
        <div className="flex gap-2 mb-3">
          <input 
            value={newTask} 
            onChange={(e) => setNewTask(e.target.value)} 
            placeholder="New task" 
            className="flex-1 p-2 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500" 
          />
          <button onClick={addTask} className="px-4 py-2 bg-pink-600 hover:bg-pink-700 text-white rounded-lg transition-colors">Add</button>
        </div>

        <div className="space-y-2 max-h-64 overflow-y-auto">
          {tasks.map(t => {
            const baseClass = `w-full text-left p-3 rounded-lg border transition-all duration-300 ease-in-out flex items-center ${
              t.done 
                ? 'bg-gray-700 border-pink-500 line-through text-gray-400' 
                : 'bg-gray-700 hover:bg-gray-600 border-gray-600 text-white'
            }`;
            const celebrateClass = t.id === celebratingId ? 'animate-bounce scale-105 ring-2 ring-pink-400 ring-opacity-50 shadow-lg' : '';
            return (
              <button 
                key={t.id} 
                onClick={() => toggleTask(t.id)} 
                className={`${baseClass} ${celebrateClass}`}
              >
                <span className={`mr-2 transition-all duration-500 ease-out flex-shrink-0 w-5 h-5 flex items-center justify-center ${
                  t.done ? 'opacity-100 scale-100 animate-pulse' : 'opacity-0 scale-0'
                } origin-left text-pink-400`}>
                  {t.done ? '🔥' : ''}
                </span>
                <span>{t.text}</span>
              </button>
            );
          })}
        </div>

        <div className="mt-4 text-sm text-gray-300 text-center">
          Tasks completed: {tasks.filter(t => t.done).length} / {tasks.length}
        </div>
        <div className="mt-2 text-sm text-pink-400 text-center">
          Coins earned today: {tasks.filter(t => t.done).length * 3}
        </div>

        <div className="mt-4 flex justify-center gap-2">
          <button onClick={resetTasks} className="px-4 py-2 rounded-lg border border-gray-600 text-sm hover:bg-gray-700 transition-colors">Reset Tasks</button>
        </div>
      </div>

      <footer className="mt-6 text-xs text-gray-500 text-center">Part of SheEarns • Progress saved locally 🌸</footer>
    </div>
  );
}